var React = require('react');

function ControlRight (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"control-right"),React.createElement("polygon",{"points":"0 7.72 10.13 15.46 0 23.49 0 30.8 18.76 15.46 0 0 0 7.72","key":1})]);
}

ControlRight.defaultProps = {"width":"18.76","height":"30.8","viewBox":"0 0 18.76 30.8"};

module.exports = ControlRight;

ControlRight.default = ControlRight;
